import { ReactNode } from 'react';
import { assertDefined } from '@/utils/assertDefined';
import { isSmall } from '@/hooks/useMediaQuery';

let store: Map<string, string>;
const tryMobileKeyFirst = isSmall();

export function init(locale: string) {
  return import(/* webpackChunkName: 'i18n/[request]' */ `./i18n/${locale}.json`).then(
    (translations) => {
      store = new Map(Object.entries(translations));
    }
  );
}

export function t(key: string, ...replacements: string[]) {
  const translationKey = key;

  let value: string | undefined;
  if (tryMobileKeyFirst) {
    value = store.get(`${translationKey}_mobile`);
  }

  if (!value) {
    value = store.get(translationKey);
  }

  if (process.env.NODE_ENV === 'development' && value === undefined) {
    console.warn(`translation for key ${translationKey} not found!`);
  }

  const replacementCount = replacements.length;
  if (value && replacementCount) {
    for (let index = 0; index < replacementCount; index++) {
      value = value.replace(`%${index}`, replacements[index]);
    }
  }

  return value || '';
}

export function tWithCount(num: number, key: string, ...replacements: string[]) {
  return t(num > 1 ? `${key}_plural` : key, ...replacements);
}

/*
 * helper to render rAppid translation template strings
 */
export const renderTemplateString = (
  string: string,
  renderFunction: (subString: string, index: number) => ReactNode
): ReactNode[] => {
  const split = assertDefined(t(string)).replace(/\[/g, '|*').replace(/]/g, '|').split(/\|/g);
  return split.map((subString, i) => {
    if (subString.startsWith('*')) {
      return renderFunction(subString.substr(1), i);
    }
    return subString;
  });
};
